import { render, staticRenderFns } from "./SelectLocale.vue?vue&type=template&id=2df038dc"
import script from "./SelectLocale.vue?vue&type=script&lang=js"
export * from "./SelectLocale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports